export default function noContract({contractName})
{
		return (
	<>
				<h1> Contract <code> "{contractName}" </code> doesn't exists yet </h1>
				<h2> <code> 404 not found </code> </h2>
				<p className="subtitle"> If you feel this should exist. Let me know through Github </p>
			</>
			)
}